<template>
    <el-collapse v-model="indicesCollapseReservaLegal">
        <el-collapse-item :name="`collapse-reserva-legal`">
            <template #title>
                <span class="titulo">{{
                    $tc('certification.messages.legal_reserve')
                }}</span>
            </template>
            <div class="collapse-item-bloco-info">
                <div class="info">
                    <label>
                        {{
                            $tc(
                                'certification.messages.vectorized_legal_reserve_area'
                            )
                        }}:
                    </label>
                    <span>{{
                        formatNumber(dados?.areaReservaLegalAverbada, 2)
                    }}</span>
                </div>
                <div class="info">
                    <label>
                        {{
                            $tc(
                                'certification.messages.approved_non_registered_vectorized_legal_reserve_area'
                            )
                        }}:
                    </label>
                    <span>{{
                        formatNumber(dados?.areaReservaLegalNaoAverbada, 2)
                    }}</span>
                </div>
                <div class="info">
                    <label>
                        {{
                            $tc(
                                'certification.messages.proposed_vectorized_legal_reserve_area'
                            )
                        }}:
                    </label>
                    <span>{{
                        formatNumber(dados?.areaReservaLegalProposta, 2)
                    }}</span>
                </div>
                <div class="info">
                    <label>
                        {{
                            $tc(
                                'certification.messages.total_declared_legal_reserve_by_owner'
                            )
                        }}:
                    </label>
                    <span>{{
                        formatNumber(dados?.areaReservaLegalDeclarada, 2)
                    }}</span>
                </div>
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import formatter from '@/utils/formatters';

export default {
    name: 'CollapseReservaLegal',
    props: {
        dados: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            indicesCollapseReservaLegal: []
        };
    },
    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        }
    }
};
</script>

<style lang="scss" scoped>
.titulo {
    font-weight: bold;
}
</style>
